import classNames from 'classnames';
import * as gravatar from 'gravatar';
import { isString } from 'lodash-es';

const fallbackImageSizePx = 40;

type User = {
  displayName: string;
  email: string;
  image?: string | null;
};

type AvatarProps = {
  user: User | null;
  className?: string;
};

export const Avatar = ({ user, className }: AvatarProps) => {
  const src = getImageUrl(user?.image, user?.email);
  let alt = 'Profilbild';

  if (isString(user?.displayName)) {
    alt += ` von ${user?.displayName}`;
  }

  return (
    <img className={classNames('tds-avatar w-600 h-600', className)} src={src} alt={alt} />
  );
};

const getImageUrl = (imageUrl?: string | null, email?: string) => {
  if (isString(imageUrl)) {
    return imageUrl;
  }

  if (isString(email)) {
    return gravatar.url(email, {
      d: 'mp',
      s: `${fallbackImageSizePx}`,
    }, true);
  }

  return `https://www.gravatar.com/avatar/?d=mm&s=${fallbackImageSizePx}&f=y`;
};
